/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Organize_HintInputs */

const en_us2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold a workout and drag it to change the order. The letters follow the order: the first is always A.`)
};

const pt_br2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segure um treino e arraste para mudar a ordem. As letras seguem a ordem: o primeiro é sempre o A.`)
};

const es_419_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén presionado un entrenamiento y arrástralo para cambiar el orden. Las letras siguen el orden: el primero siempre es la A.`)
};

const pt_pt2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantém um treino premido e arrasta-o para mudar a ordem. As letras seguem a ordem: o primeiro é sempre o A.`)
};

const fr_fr2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintiens une séance et fais-la glisser pour changer l'ordre. Les lettres suivent l'ordre : la première est toujours A.`)
};

const de_de2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halte ein Training gedrückt und zieh es, um die Reihenfolge zu ändern. Die Buchstaben folgen der Reihenfolge: Das erste ist immer A.`)
};

const it_it2_plan_build_organize_hint = /** @type {(inputs: Plan_Build_Organize_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieni premuto un allenamento e trascinalo per cambiare l'ordine. Le lettere seguono l'ordine: il primo è sempre A.`)
};

/**
* | output |
* | --- |
* | "Hold a workout and drag it to change the order. The letters follow the order: the first is always A." |
*
* @param {Plan_Build_Organize_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_hint = /** @type {((inputs?: Plan_Build_Organize_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_hint(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_hint(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_hint(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_hint(inputs)
	return en_us2_plan_build_organize_hint(inputs)
});
export { plan_build_organize_hint as "plan-build.organize_hint" }